/*** IMPORTS FROM imports-loader ***/
var define = false;

// A (possibly faster) way to get the current timestamp as an integer.
export default Date.now || function() {
  return new Date().getTime();
};




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/now.js
// module id = 41
// module chunks = 0